module.exports = __webpack_public_path__ + "assets/bd01f6ef01e8d0165db1c77171bd969e.mp3";